import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-maxlength';

export function validateMaxLength(element: HTMLInputElement, maxLen: number): boolean {
    if (element.value.length > maxLen) {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}

export function liveValidateMaxLength(element: HTMLInputElement) {
    const maxLen = parseInt(element.getAttribute('maxlength') as string, 10);
    if (isNaN(maxLen)) {
        return;
    }

    // We need to check every keypress to make pulse nice.
    element.addEventListener('keypress', (e: Event) => {
        // TODO: Does this work in FF and IE?
        // It is worth noting that currently getSelection() doesn't work on the content of <textarea> and <input> elements in Firefox, Edge (Legacy) and Internet Explorer.
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/getSelection
        try {
            const selStart = element.selectionStart;
            const selEnd = element.selectionEnd;
            if (selStart !== null && selEnd !== null) {
                if (selStart - selEnd !== 0) {
                    // Len is currently 15, but as there is selection it will be < 15.
                    return;
                }
            }
        } catch (exception) {}

        element.classList.remove('pulse--validate-maxlength');
        if (element.value.length >= maxLen) {
            const foobar = element.offsetWidth; // Trigger browser bugs/reflow. Either this or setTimeout.
            element.classList.add('pulse--validate-maxlength');
            e.preventDefault();
            return false;
        }
        return;
    });

    element.addEventListener('input', (e: Event) => {
        return validateMaxLength(element, maxLen);
    });
    element.addEventListener('change', (e: Event) => {
        return validateMaxLength(element, maxLen);
    });
    element.addEventListener('blur', (e: Event) => {
        return validateMaxLength(element, maxLen);
    });
}
